import { FC, ReactNode } from "react";
import classNames from "classnames";

import { uiConstants } from "../../../constants";
import { UIStatus } from "../../../types/GlobalTypes";

export enum Size {
  MD = "md p-4",
  XXL = "2xl p-4 md:p-8",
}

type Props = {
  children: ReactNode;
  className?: string;
  dataTest?: string;
  onClick?: (args: any) => void;
  size?: Size;
  disabled?: boolean;
  uiStatus?: UIStatus;
  error?: boolean;
};

export const Card: FC<Props> & { size: typeof Size } = ({
  children,
  className,
  dataTest,
  onClick,
  size = Size.XXL,
  disabled,
  uiStatus,
  error,
}) => {
  const uiStatusStyles = uiStatus ? uiConstants[uiStatus] : undefined;

  return (
    <div
      className={classNames(
        "border border-gray-100",
        {
          "cursor-pointer": !!onClick && !disabled,
          "bg-white": !disabled,
          "bg-violet-50": disabled,
          "!bg-orange-50 !border-orange-100": error,
        },
        `rounded-${size}`,
        uiStatusStyles
          ? `${uiStatusStyles?.backgroundColor} ${uiStatusStyles?.borderColor}`
          : undefined,
        className
      )}
      data-test={dataTest}
      onClick={disabled ? () => {} : onClick}
    >
      {children}
    </div>
  );
};

Card.size = Size;
